<template>
  <a-card hoverable>
    <img
      slot="cover"
      v-if="productImage != null && productImage != ''"
      :src="productImage"
    />
    <img slot="cover" v-else src="@/assets/images/productblank.png" />
    <template slot="actions" class="ant-card-actions">
      <a-icon type="info" />
      <a-icon type="plus" @click="handleBtnAddToCart" />
    </template>
    <a-card-meta :title="productName"> </a-card-meta>
  </a-card>
</template>
<script>
//import allergyIcons from '../../components/icons/sources.js'
export default {
  name: 'ProductCard',
  components: {},
  props: {
    productId: { type: String },
    productName: { type: String },
    productPrice: { type: Number },
    productTax: { type: Number },
    productCategory: { type: String },
    productImage: { type: String },
    productDescription: { type: String },
    productOptions: { type: String },
    productAllergyIcons: { type: String },
    estimatedTime: { type: Number },
    isOutOfStock: { type: Boolean },
  },

  data() {
    return {};
  },

  methods: {
    handleBtnAddToCart() {
      //console.log('add button clicked!')
      let item = {
        itemId: this.productId,
        itemName: this.productName,
        itemPrice: this.productPrice,
        categoryName: this.productCategory,
        tax: this.productTax,
        options: [],
        isCustomized: false,
        addedPrice: 0.0,
        estimatedTime: this.estimatedTime,
        quantity: 1,
        comment: '',
        groupOptionsModel: this.productOptions,
        imageUrl: this.productImage,
      };

      this.$emit('productAddedToCart', item);
    },

    getAllergies() {
      let allergies = [];
      try {
        allergies = allergyIcons.getAllergyIcons(
          JSON.parse(this.productAllergyIcons)
        );
      } catch (ex) {
        console.log(ex);
      } finally {
        //console.log(allergies)
        return allergies;
      }
    },

    getProductOptions() {
      let options = [];

      if (this.productOptions !== null) {
        try {
          options = JSON.parse(this.productOptions);
        } catch (err) {
          console.log('Error in product options: ' + err);
        } finally {
          //console.log(options);
          return options;
        }
      } else {
        return options;
      }
    },
  },
  created() {},
};
</script>

<style lang="scss"></style>
